import React, { useState } from 'react'

import { ReportEmpty } from '@/components/reports/body'

import ProgressionBody from './ProgressionBody'

const ProgressionResults = ({ data, progressionType }) => {
  const [shownCard, setShownCard] = useState(0)

  if (!data) {
    return <div className='font-semibold text-center'>Please select a site in configure section.</div>
  }

  if (!data.length) {
    return <ReportEmpty><div className='font-semibold text-center'>No results to show.</div></ReportEmpty>
  }

  return <div className='flex flex-col gap-4'>
    {data.map((item, idx) => <ProgressionBody
      key={item.id}
      item={item}
      progressionType={progressionType}
      isShow={shownCard === idx}
      onShow={() => setShownCard(idx)}
    />)}
  </div>
}

export default ProgressionResults
